import React, { useState, useEffect } from 'react';
import { Clock, Calendar } from 'lucide-react';

const LiveClock = (props) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const getGreeting = () => {
    const hour = currentTime.getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 18) return 'Good Afternoon';
    return 'Good Evening';
  };

  const { customColor } = props;
  const primaryColor = customColor || '#0d9488'; // Default to teal-600 if no color provided

  return (
    <div
      className="rounded-lg shadow-lg p-6 text-white border transition-colors duration-300"
      style={{
        backgroundColor: primaryColor,
        borderColor: primaryColor
      }}
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Clock className="h-5 w-5" />
          <span className="text-sm font-medium">Live</span>
        </div>
        <div className="flex items-center gap-2">
          <Calendar className="h-5 w-5" />
        </div>
      </div>

      {/* Greeting */}
      <div className="mb-4">
        <h3 className="text-lg font-semibold">{getGreeting()}</h3>
      </div>

      {/* Time Display */}
      <div className="mb-4">
        <div className="text-5xl font-bold tracking-tight font-mono">
          {formatTime(currentTime)}
        </div>
      </div>

      {/* Date Display */}
      <div
        className="pt-4 border-t"
        style={{ borderColor: 'rgba(255, 255, 255, 0.2)' }}
      >
        <p className="text-sm">{formatDate(currentTime)}</p>
      </div>
    </div>
  );
};

export default LiveClock;
